export default __webpack_public_path__ + "static/media/guinea-pig-bg.ee262f58.webp";